import React from "react";

const PreparationTime = () => {
  return <div>Preparation Time</div>;
};

export default PreparationTime;
